import { render, staticRenderFns } from "./DigitalBrokerPolicyList.vue?vue&type=template&id=68044040"
import script from "./DigitalBrokerPolicyList.vue?vue&type=script&lang=js"
export * from "./DigitalBrokerPolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports